import { Injectable } from '@angular/core';

@Injectable()
export class ChartLayoutService {
  static readonly CHART_LAYOUT_DATA_KEY = 'chart-layout-data';

  loadChartLayout(is: string = null) {
    const serializedData = localStorage.getItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY);

    if (serializedData) {
      return JSON.parse(serializedData);

      // savedChartLayout.charts[0].panes[0].sources[0].state.symbol=this.pair;
      // savedChartLayout.charts[0].panes[0].sources[0].state.shortName=this.pair;
      // this.chart.load(savedChartLayout);
    }

    return null;
  }

  saveChartLayout(data: any, id: string = null) {
    const stylesRemovedData = data?.charts.map(chart => {
      const {chartProperties, ...restOfProperties} = chart;
      return restOfProperties;
    });
    const serializedData = JSON.stringify({...data, charts: stylesRemovedData});
    window.localStorage.setItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY, serializedData);
  }
}
